import React from 'react';
import { Space } from '@douyinfe/semi-ui';
import { FaTelegram, FaRedditSquare } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';

class SocialSection extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="socials-section">
                <Space>
                    <a href="https://x.com/cyberrose_dev" className="social-icon" aria-label="CyberRose on X" target="_blank" rel="noopener noreferrer"><FaSquareXTwitter /></a>
                    <a href="https://t.me/cyberrose_dev" className="social-icon" aria-label="CyberRose on Telegram" target="_blank" rel="noopener noreferrer"> <FaTelegram /></a>
                    <a href="https://www.reddit.com/r/cyberrose_dev/" className="social-icon" aria-label="CyberRose on Reddit" target="_blank" rel="noopener noreferrer"> <FaRedditSquare /></a>
                </Space>
            </div>
        );
    }
}

export default SocialSection;